import { Payload, Types } from 'states/dux/amenity/types'
import { Action } from 'states/types'

const set = (payload: Payload): Action<Payload> => {
  return {
    type: Types.SET,
    payload
  }
}

const add = (payload: Payload): Action<Payload> => {
  return {
    type: Types.ADD,
    payload
  }
}

const update = (payload: Payload): Action<Payload> => {
  return {
    type: Types.UPDATE,
    payload
  }
}

const setLoading = (loading: boolean): Action<Payload> => {
  return {
    type: Types.LOADING,
    payload: {
      loading,
      data: []
    }
  }
}

export { set, add, update, setLoading }
